































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapActions, mapGetters } from 'vuex';

@Component
export default class OrdersListItems extends Vue {
  @Prop({ default: [] }) items: Array<Object>;
  
  get dateFormat() {
    return (date: Date|string) => {
      return this.$moment(date).format('YYYY-MM-DD HH:mm');
    }
  }

  get isCompact() {
    return this.$vuetify.breakpoint.mdAndDown;
  }

  get isExtraLarge() {
    return this.$vuetify.breakpoint.xl; 
  }
}
